import { getSizedImageUrl } from '@shopify/theme-images'
import { formatMoney } from './utils/shopify'

export const money = (el, { expression }, { evaluateLater, effect }) => {
    const getValue = evaluateLater(expression)

    effect(() => {
        getValue((value) => {
            el.textContent = formatMoney(value)
        })
    })
}

export const imageTransform = (
    el,
    { expression, modifiers },
    { evaluateLater, effect }
) => {
    const getValue = evaluateLater(expression)
    const transform = modifiers[0] ?? null

    effect(() => {
        getValue((value) => {
            el.setAttribute('src', getSizedImageUrl(value, transform))
        })
    })
}
